// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPayor {
    static getAttributeTypeMap() {
        return MedicalBiPayor.attributeTypeMap;
    }
}
MedicalBiPayor.discriminator = undefined;
MedicalBiPayor.additionalProperties = false;
MedicalBiPayor.attributeTypeMap = [
    {
        "name": "payorId",
        "baseName": "payorId",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "planName",
        "baseName": "planName",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPayor.js.map